import { compose, withProps } from 'recompose'
import Banner from './Banner'
import { transformTitle } from 'components/HyperLocalPages/helpers'

const withBannerProps = withProps(({
  title
}) => ({
  title: transformTitle(title)
}))

export default compose(
  withBannerProps
)(Banner)

